import VideoPlayer from "@entities/videoPlayer/ui/VideoPlayer";
import {
  IDraftingComments,
  IDraftingDrawings,
  IDraftingMediaAssets,
} from "@shared/lib/types/drafting";
import { Empty } from "antd";

export function DraftMediaPreview({
  asset,
  draftingId,
  draftingVersionId,
  mediaAssetId,
  onAddCommentAt,
  currentTime,
  onTimeChange,
  isDrawingEnabled,
  draftDrawings,
  onUpdateDraftDrawings,
  activeDrawing,
  comments,
}: {
  asset?: IDraftingMediaAssets;
  currentTime: number;
  onTimeChange: (value: number) => void;
  onAddCommentAt: (time: number) => void;
  isDrawingEnabled: boolean;
  draftDrawings: IDraftingDrawings[];
  onUpdateDraftDrawings: (drawings: IDraftingDrawings[]) => void;
  activeDrawing: IDraftingDrawings[] | null;
  comments: IDraftingComments[];
  draftingId: string;
  draftingVersionId: string;
  mediaAssetId: string;
}) {
  if (!asset) {
    return (
      <Empty
        description="Select an asset to preview"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    );
  }

  return (
    <VideoPlayer
      asset={asset}
      currentTime={currentTime}
      onTimeUpdate={onTimeChange}
      onAddCommentRequest={onAddCommentAt}
      isDrawingMode={isDrawingEnabled}
      draftDrawings={draftDrawings}
      onUpdateDraftDrawings={onUpdateDraftDrawings}
      activeDrawing={activeDrawing}
      comments={comments}
      draftingId={draftingId}
      draftingVersionId={draftingVersionId}
      mediaAssetId={mediaAssetId}
    />
  );
}
